import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  PageHeight30,
  PageTitle,
  scrollToTop,
} from "../../../components/Utils";
import { Label } from "../../../components/Inputs";
import { FormMenu } from "../../../components/Buttons";
import MessageForm from "../components/MessageForm";
import MediaUploadForm from "../../../components/MediaUploadForm";
import SignatureMenu from "./SignatureMenu";
import { buildSignature } from "../components/SignatureForm";

import { connect } from "react-redux";
import { frontloadConnect } from "react-frontload";
import {
  loadContractGivers,
  loadContractors,
  sendMessage,
  loadRoles,
  loadOptions,
  loadSignature,
} from "../actions";

const MAX_TOTAL_FILESIZE = 20000000;

const frontload = async (props) => {
  // await props.getRoles();
  await props.getOptions();
  await props.getSignature();
};
const mapStateToProps = (state) => {
  return {
    isLoading: state.news.sending || state.news.loading,
    roles: state.news.roles,
    // footPrints: state.news.footPrints,
    footPrintOptions: state.news.footPrintOptions,
    footPrintGroups: state.news.footPrintGroups,
    footPrintGroupOptions: state.news.footPrintGroupOptions,
    // companyGroupOptions: state.news.companyGroupOptions,
    signature: state.news.signature,
  };
};
const mapDispatchToProps = (dispatch) => ({
  // getContractGivers: (...args) => dispatch(loadContractGivers(...args)),
  // getContractors: (...args) => dispatch(loadContractors(...args)),
  // getRoles: (...args) => dispatch(loadRoles(...args)),
  getOptions: (...args) => dispatch(loadOptions(...args)),
  getSignature: (...args) => dispatch(loadSignature(...args)),
  sendMessage: (...args) => dispatch(sendMessage(...args)),
});

function MessagePanel({
  className = "margin-big-top",
  isLoading,
  // roles,
  footPrintGroups,
  footPrintGroupOptions,
  // companyGroupOptions,
  signature,
  sendMessage,
}) {
  const messageFormRef = React.useRef(null);
  const mediaFormRef = React.useRef(null);
  const buttonPanelRef = React.useRef(null);
  React.useEffect(() => {
    return () => {
      scrollToTop();
    };
  }, []);

  const onSend = React.useCallback(() => {
    if (
      !messageFormRef.current ||
      !messageFormRef.current.getModel ||
      !mediaFormRef.current ||
      !mediaFormRef.current.getModel ||
      !buttonPanelRef.current ||
      !buttonPanelRef.current.toggleDisabled
    ) {
      console.error("Missing form references");
      return;
    }
    // basic message
    const message = messageFormRef.current.getModel();
    // add signature
    message.text += buildSignature(signature);
    // get attachments
    const { media } = mediaFormRef.current.getModel();
    message.attachments = media && media.length > 0 ? media : [];
    // send
    console.log("Sending ...", message);
    buttonPanelRef.current.toggleDisabled(true);
    sendMessage({
      message,
      onSuccess: () => {
        buttonPanelRef.current.toggleDisabled(false);
        messageFormRef.current.reset();
        scrollToTop();
      },
    });
  }, [
    signature,
    sendMessage,
    messageFormRef.current,
    mediaFormRef.current,
    buttonPanelRef.current,
  ]);

  const onFormUpdated = React.useCallback(
    (isValid) => {
      let disabled = !isValid;
      if (mediaFormRef.current && mediaFormRef.current.getTotalFileSize) {
        const isFilesValid =
          mediaFormRef.current.getTotalFileSize() < MAX_TOTAL_FILESIZE;
        disabled = disabled || !isFilesValid;
      }
      if (buttonPanelRef.current && buttonPanelRef.current.toggleDisabled) {
        buttonPanelRef.current.toggleDisabled(disabled);
      }
    },
    [mediaFormRef.current, buttonPanelRef.current],
  );

  const onFilesUpdated = React.useCallback(
    (isValid) => {
      let disabled = !isValid;
      if (messageFormRef.current && messageFormRef.current.getTotalFileSize) {
        const isFormValid = messageFormRef.current.getModel() !== null;
        disabled = disabled || !isFormValid;
      }
      if (buttonPanelRef.current && buttonPanelRef.current.toggleDisabled) {
        buttonPanelRef.current.toggleDisabled(disabled);
      }
    },
    [messageFormRef.current, buttonPanelRef.current],
  );

  const signatureMarkupStr = buildSignature(signature);
  const year = moment().year();
  const titlePrefixOptions = [
    "ad-hoc News",
    "Firmeninformation",
    "Info & Update",
  ].map((item) => ({
    label: `${year} ${item}`,
    value: `${year}-<Anzahl> ${item}`,
  }));

  return (
    <PageHeight30 id="/nachrichten" className={`${className}`}>
      <PageTitle>
        <SignatureMenu className="w3-right" />
        <h3 className="no-margin">News Einstellen</h3>
      </PageTitle>
      <div className="pad-big w3-border no-border-btm">
        <p>Über diese Seite können E-Mails versandt werden.</p>
      </div>
      <div className="pos-relative">
        {isLoading && (
          <div
            className="w3-border"
            style={{
              position: "absolute",
              top: "0px",
              left: "0px",
              width: "100%",
              height: "100%",
              background: "#fff",
              zIndex: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        )}
        <MessageForm
          ref={messageFormRef}
          className="pad-big w3-border"
          // roles={roles}
          // companyGroupOptions={companyGroupOptions}
          footPrintGroups={footPrintGroups}
          footPrintGroupOptions={footPrintGroupOptions}
          titlePrefixOptions={titlePrefixOptions}
          onUpdated={onFormUpdated}
          signature={signatureMarkupStr}
        />
      </div>
      <MediaUploadForm
        ref={mediaFormRef}
        className="margin-big-top pad-big w3-border"
        title={`Anhänger`}
        uploadBtnClassName="w3-right"
        uploadUrl="/data-api/media/upload?target=news"
        itemRowClassName="neg-margin-lr"
        itemColClassName="w3-col s3"
        btnLabel="Datei hochladen"
        // model={{ files: attachments }}
        max={null}
        maxTotalFileSize={MAX_TOTAL_FILESIZE}
        onUpdated={onFilesUpdated}
        showFileName
      />
      <ButtonPanel
        ref={buttonPanelRef}
        className="w3-border margin-big-top pad-big w3-light-grey"
        onSend={onSend}
      />
    </PageHeight30>
  );
}

MessagePanel.propTypes = {
  roles: PropTypes.array,
  footPrintOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
  footPrintGroups: PropTypes.arrayOf(PropTypes.shape({})),
  footPrintGroupOptions: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
  ),
  // companyGroupOptions: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     label: PropTypes.string.isRequired,
  //     value: PropTypes.string.isRequired,
  //   }),
  // ),
  // getRoles: PropTypes.func.isRequired,
  getOptions: PropTypes.func.isRequired,
  getSignature: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  })(MessagePanel),
);

function ButtonPanelModule({ forwardedRef, className, onSend }) {
  const [disabled, setDisabled] = React.useState(true);
  const toggleDisabled = (disabled) => setDisabled(disabled);
  React.useImperativeHandle(forwardedRef, () => ({ toggleDisabled }));
  console.log("ButtonPanelModule() disabled:", disabled);

  return (
    <FormMenu
      className={className}
      onSave={onSend}
      saveBtnLabel="Nachricht senden"
      saveBtnName="closeMessageBtn"
      saveDisabled={disabled}
      cancelHidden
    />
  );
}

ButtonPanelModule.propTypes = {
  onSend: PropTypes.func,
  className: PropTypes.string,
};

const ButtonPanel = React.forwardRef((props, ref) => (
  <ButtonPanelModule {...props} forwardedRef={ref} />
));
